import Vue from 'vue'
import { Toast } from 'vant'

export default {
  namespaced: true,
  state: {
    flowId: '',
    callBack: '', // 回调地址
    list: [], // 文件
    contractNum: '', // 当前文件id
    signList: [], // 签名列表
    mobile: '', // 虚拟手机号
    wxCallBack: '',
    type: null,
    dateImage: false,
    hideSeal: true, // 是否显示已有签名（true: 显示 false: 隐藏）
    canAddSign: true, // 是否可以添加新签名
  },
  mutations: {
    initData(state) {
      state.flowId = ''
      state.callBack = ''
      state.list = []
      state.contractNum = ''
      state.positionList = []
      state.mobile = ''
      state.wxCallBack = ''
      state.type = null
      state.dateImage = false
      state.hideSeal = true
      state.canAddSign = true
    },
    setType(state, payload) {
      const { type } = payload
      state.type = type
    },
    setMobile(state, payload) {
      const { mobile } = payload
      state.mobile = mobile
    },

    setHideSeal(state, payload) {
      const { hideSeal } = payload
      state.hideSeal = hideSeal
    },
    setfileInfo(state, payload) {
      const { flowId, callBack, wxCallBack, type, dateImage } = payload
      state.flowId = flowId
      state.callBack = decodeURIComponent(callBack)
      state.wxCallBack = decodeURIComponent(wxCallBack)
      state.type = type
      state.dateImage = dateImage
    },
    setfileList(state, payload) {
      const { list } = payload
      state.list = list
      state.contractNum = list[0].contractNum
    },
    // 更换当前文件
    changeFile(state, payload) {
      const { contractNum } = payload
      state.contractNum = contractNum
    },
    setSignList(state, payload) {
      const { list, canAddSign } = payload
      state.signList = list
      if (canAddSign !== undefined) {
        state.canAddSign = canAddSign
      }
    },
    // 未指定位置放置印章
    pushPositionList(state, payload) {
      const index = state.list.findIndex((e) => {
        return e.contractNum === state.contractNum
      })
      state.list[index].positionList.push(payload)
    },
    // 指定位置放置印章
    fillPositionList(state, payload) {
      const { i, sealData } = payload
      const index = state.list.findIndex((e) => {
        return e.contractNum === state.contractNum
      })
      const val = {
        signId: sealData.signId,
        signImg: sealData.signImg,
        width: sealData.width,
        height: sealData.height,
        y: state.list[index].positionList[i].y + (140 - sealData.height) * 0.75,
      }
      Vue.set(state.list[index].positionList, i, {
        ...state.list[index].positionList[i],
        ...val,
      })
    },
    deletePositionList(state, payload) {
      const index = state.list.findIndex((e) => {
        return e.contractNum === state.contractNum
      })
      const { i } = payload
      state.list[index].positionList.splice(i, 1)
    },
  },
  actions: {
    getTransformParams({ commit, state }, payload) {
      const { list, dateImage } = state
      let btn = true // 是否都签署
      const newList = list.filter((e) => e.isFinish === 1)
      if (newList.every((e) => e.positionList && e.positionList.length)) {
        newList.forEach((e) => {
          e.positionList.forEach((item) => {
            if (!item.signId) {
              btn = false
            }
          })
        })
      } else {
        btn = false
      }
      if (btn) {
        const signInfo = []
        newList.forEach((e) => {
          e.positionList.forEach((item) => {
            signInfo.push(item)
          })
        })
        const newSignInfo = []
        signInfo.forEach((e) => {
          let obj
          if (e.positionName && e.signType) {
            newSignInfo.push({
              contractNum: e.contractNum,
              positionName: e.positionName,
              signId: e.signId,
              signType: 0,
            })
            if (!dateImage) {
              newSignInfo.push({
                contractNum: e.contractNum,
                page: e.page,
                x: e.x.toFixed(2) * 1,
                y: (842 - e.y - e.height * 0.75 - 31).toFixed(2) * 1,
                signType: 1,
              })
            }
          } else if (e.positionName && !e.signType) {
            newSignInfo.push({
              contractNum: e.contractNum,
              positionName: e.positionName,
              signId: e.signId,
              signType: 0,
            })
          } else if (!e.positionName && e.signType) {
            newSignInfo.push({
              contractNum: e.contractNum,
              page: e.page,
              x: e.x.toFixed(2) * 1,
              y: (842 - e.y - e.height * 0.75).toFixed(2) * 1,
              signId: e.signId,
              signType: 0,
            })
            if (!dateImage) {
              newSignInfo.push({
                contractNum: e.contractNum,
                page: e.page,
                x: e.x.toFixed(2) * 1,
                y: (842 - e.y - e.height * 0.75 - 31).toFixed(2) * 1,
                signType: 1,
              })
            }
          } else if (!e.positionName && !e.signType) {
            newSignInfo.push({
              contractNum: e.contractNum,
              page: e.page,
              x: e.x.toFixed(2) * 1,
              y: (842 - e.y - e.height * 0.75).toFixed(2) * 1,
              signId: e.signId,
              signType: 0,
            })
          }
          return obj
        })
        console.log(newSignInfo)
        const params = {
          signInfo: JSON.stringify(newSignInfo),
          flowId: state.flowId,
        }
        return params
      }
      Toast('您还有文件没签署')
    },
  },
  getters: {
    file: (state) => {
      return state.list.find((e) => e.contractNum === state.contractNum)
    },
    noSignFile: (state) => {
      return state.list.find((e) => e.isFinish === 0 && e.signList.length === 0)
    },
    signList: (state) => {
      return state.list.filter((e) => e.isFinish === 1)
    },
  },
}
